import Component from '../abstracts/Component';

export default class BenefitBarComponent extends Component {
  get COMPONENTNAME() {
    return 'BenefitBarComponent';
  }

  get SELECTORS() {
    return {
      messagesPlaceholder: '[data-benefit-bar-messages]',
    };
  }

  get CLASSES() {
    return {
      benefitBarMessageIdentifier: 'benefit-bar-message-',
      benefitBarCurrentMessage: '--current-message',
      benefitBarIncomingMessage: '--incoming-message',
      benefitBarOutgoingMessage: '--outgoing-message',
      benefitBarHide: '--hide',
      benefitBarHideByScroll: '--hide-by-scroll',
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.dom = {
      messagesPlaceholder: this.$component.querySelector(
        this.SELECTORS.messagesPlaceholder
      ),
    };
  }

  initBenefitBar() {
    let currentMessageIndex = 0;
    let isMouseIn = false;
    let touchInteraction = false;

    const benefitBar = this.dom.messagesPlaceholder;
    const benefitBarMessages = [...benefitBar.children];

    if (benefitBarMessages.length > 0) {
      benefitBarMessages[0].classList.add(
        this.CLASSES.benefitBarCurrentMessage
      );
      if (benefitBarMessages.length > 1) {
        const messageTimeInterval = parseInt(
          this.dom.messagesPlaceholder.dataset.duration || 3000
        );
        let changeMessageTimeout = null;

        const setChangeMessageTimeout = () => {
          changeMessageTimeout = setTimeout(
            () => changeMessage(),
            messageTimeInterval
          );
        };

        const changeMessage = () => {
          let newMessageIndex = currentMessageIndex + 1;
          if (newMessageIndex === benefitBarMessages.length)
            newMessageIndex = 0;

          const currentMessageElement = benefitBarMessages.find(
            (currentElement) =>
              currentElement.classList.contains(
                `${this.CLASSES.benefitBarMessageIdentifier}${currentMessageIndex}`
              )
          );
          const nextMessageElement = benefitBarMessages.find((currentElement) =>
            currentElement.classList.contains(
              `${this.CLASSES.benefitBarMessageIdentifier}${newMessageIndex}`
            )
          );

          currentMessageElement.classList.add(
            this.CLASSES.benefitBarOutgoingMessage
          );
          nextMessageElement.classList.add(
            this.CLASSES.benefitBarIncomingMessage
          );
          setTimeout(() => {
            nextMessageElement.classList.remove(
              this.CLASSES.benefitBarIncomingMessage
            );
            nextMessageElement.classList.add(
              this.CLASSES.benefitBarCurrentMessage
            );
            currentMessageElement.classList.remove(
              this.CLASSES.benefitBarCurrentMessage
            );
            currentMessageElement.classList.remove(
              this.CLASSES.benefitBarOutgoingMessage
            );
            currentMessageIndex = newMessageIndex;
            if (!isMouseIn) setChangeMessageTimeout();
          }, 500);
        };

        benefitBar.addEventListener('touchend', () => {
          touchInteraction = true;
          if (changeMessageTimeout === null) setChangeMessageTimeout();
        });

        benefitBar.addEventListener('mouseenter', () => {
          if (!touchInteraction) {
            isMouseIn = true;
            clearTimeout(changeMessageTimeout);
          }
          touchInteraction = false;
        });

        benefitBar.addEventListener('mouseleave', () => {
          if (isMouseIn) {
            isMouseIn = false;
            setChangeMessageTimeout();
          }
        });

        setChangeMessageTimeout();
      }
    }
  }

  bindEvents() {
    this.$on(this.$customEvents.BENEFIT_BAR_EVENTS.show, () => {
      this.$component.classList.remove(this.CLASSES.benefitBarHide);
      this.$component.classList.remove(this.CLASSES.benefitBarHideByScroll);
    });
    this.$on(this.$customEvents.BENEFIT_BAR_EVENTS.hide, () => {
      this.$component.classList.add(this.CLASSES.benefitBarHide);
      this.$component.classList.remove(this.CLASSES.benefitBarHideByScroll);
    });
    this.$on(this.$customEvents.BENEFIT_BAR_EVENTS.hideByScroll, () => {
      this.$component.classList.add(this.CLASSES.benefitBarHideByScroll);
    });
  }

  render() {
    super.render();
    this.initBenefitBar();
    this.bindEvents();
  }
}
